









































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { dictServe, institutionServer, performanceServer, temporaryWorkServer } from '@/api/installServer';
import AddDialog from '@/views/risk/temporaryHomeworkReporting/unit/addDialog.vue';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { AddDialog, CollapseTransition, PagingUnit },
  mixins: [TableStripe],
})
export default class TemporaryHomeworkReporting extends Vue {
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 总共多少条数据
  // table 数据对象
  tableData: any = [];

  searchForm: any = {
    companyId: '',
    contact: '',
    content: '',
  };
  dateArr: any = [];
  subSpaceByAuthOptions: any[] = [];

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.getSubSpaceByAuth();
    this.getPageData();
  }
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  // 创建开始点击事件
  createExam(type: any, data?: any) {
    const detailsDialog: any = 'detailsDialog';
    const detailsDialogRef: any = this.$refs[detailsDialog];
    detailsDialogRef.showAddDialog(type, data);
  }

  // 打开删除事件
  deleteAssessStandConfig(id: any) {
    this.$confirm('确认要删除该条数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        temporaryWorkServer.removeTemporaryWorkPermit(id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('数据删除成功！');
            this.getListData();
          } else {
            this.$message.error(res.msg);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  async getPageData() {
    try {
      const res: any = await temporaryWorkServer.getTemporaryWorkPermit({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        companyId: this.searchForm.companyId,
        contact: this.searchForm.contact || null,
        content: this.searchForm.content || null,
        startTime: this.dateArr && this.dateArr.length ? this.dateArr[0] : null,
        endTime: this.dateArr && this.dateArr.length ? this.dateArr[1] : null,
      });
      if (res.code === '200') {
        this.tableData = res.data.records;
        this.total = res.data.total;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.searchForm = {
      companyId: '',
      contact: '',
      content: '',
      startTime: null,
      endTime: null,
    };
    this.getPageData();
  }
}
